module.exports = __webpack_public_path__ + "img/rongyu2.dc689a10.jpeg";